import script from "./BankReconciliationCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./BankReconciliationCreate.vue?vue&type=script&setup=true&lang=js"

import "./BankReconciliationCreate.vue?vue&type=style&index=0&id=0f4b04ac&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4b04ac"]])

export default __exports__